// extracted by mini-css-extract-plugin
module.exports = {"animate":"Block_animate__16wGm","example":"Block_example__2GGQe","size":"Block_size__18or7"};